var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 150,
    viewBox: "0 0 139 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(-269 -2872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 69.5,
    cy: 69.5,
    r: 69.5,
    transform: "translate(261 2880)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(322 2872)",
    fill: "#f36822"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(344 3007)",
    fill: "#1c3557"
  })), /*#__PURE__*/React.createElement("g", {
    id: "management",
    transform: "translate(313.832 2917.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4647",
    "data-name": "Path 4647",
    d: "M172.367,168a3.867,3.867,0,1,0,3.867,3.867A3.867,3.867,0,0,0,172.367,168Zm0,5.8a1.933,1.933,0,1,1,1.933-1.933A1.934,1.934,0,0,1,172.367,173.8Zm0,0",
    transform: "translate(-147.699 -147.701)",
    fill: "#6c6a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4648",
    "data-name": "Path 4648",
    d: "M156.1,385.933h-5.4L148.767,384h-2.334a1.933,1.933,0,0,0-1.933,1.933v7.734a1.934,1.934,0,0,0,1.933,1.933H156.1a1.934,1.934,0,0,0,1.933-1.933v-5.8A1.933,1.933,0,0,0,156.1,385.933Zm0,7.734h-9.667v-7.734h1.533l1.933,1.933h6.2Zm0,0",
    transform: "translate(-126.599 -337.6)",
    fill: "#6c6a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4649",
    "data-name": "Path 4649",
    d: "M12.1,385.933H6.7L4.767,384H2.433A1.933,1.933,0,0,0,.5,385.933v7.734A1.934,1.934,0,0,0,2.433,395.6H12.1a1.934,1.934,0,0,0,1.933-1.933v-5.8A1.933,1.933,0,0,0,12.1,385.933Zm0,7.734H2.433v-7.734H3.967L5.9,387.867h6.2Zm0,0",
    transform: "translate(0 -337.6)",
    fill: "#6c6a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4650",
    "data-name": "Path 4650",
    d: "M300.1,385.933h-5.4L292.767,384h-2.334a1.933,1.933,0,0,0-1.933,1.933v7.734a1.934,1.934,0,0,0,1.933,1.933H300.1a1.933,1.933,0,0,0,1.933-1.933v-5.8A1.933,1.933,0,0,0,300.1,385.933Zm0,7.734h-9.667v-7.734h1.533l1.933,1.933h6.2Zm0,0",
    transform: "translate(-253.199 -337.6)",
    fill: "#6c6a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4651",
    "data-name": "Path 4651",
    d: "M85.235,319.734V314.9h-17.4V312H65.9v2.9H48.5v4.833h1.933v-2.9H65.9v2.9h1.933v-2.9H83.3v2.9Zm0,0",
    transform: "translate(-42.2 -274.301)",
    fill: "#6c6a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4652",
    "data-name": "Path 4652",
    d: "M17.143,25.132h2.9v1.933h4.429c.017.041.032.08.049.119L21.4,30.314l4.1,4.1,3.129-3.129.119.05v4.433h5.8V31.337l.119-.05,3.129,3.125,4.1-4.1-3.13-3.129c.017-.039.033-.078.05-.119h4.433V25.132h1.933A9.667,9.667,0,1,0,41.459,6.544,10.634,10.634,0,0,0,21.181,8.729a8.7,8.7,0,1,0-4.038,16.4Zm24.168,0h-3.9l-.209.685a5.77,5.77,0,0,1-.456,1.1l-.346.635,2.757,2.757-1.369,1.369-2.758-2.758-.635.348a5.854,5.854,0,0,1-1.1.455l-.685.209v3.9H30.677v-3.9l-.685-.209a5.854,5.854,0,0,1-1.1-.455l-.635-.348L25.5,31.683l-1.369-1.369,2.757-2.757-.346-.635a5.8,5.8,0,0,1-.455-1.1l-.209-.685h-3.9V23.2h3.9l.209-.685a5.79,5.79,0,0,1,.455-1.1l.346-.635-2.757-2.757L25.5,16.648l2.758,2.758.635-.348a5.855,5.855,0,0,1,1.1-.455l.685-.209V14.5H32.61v3.9l.685.209a5.855,5.855,0,0,1,1.1.455l.635.348,2.758-2.758,1.369,1.369L36.4,20.774l.346.635a5.762,5.762,0,0,1,.456,1.1l.209.685h3.9ZM17.143,9.665a6.779,6.779,0,0,1,4.228,1.489.967.967,0,0,0,1.572-.731A8.7,8.7,0,0,1,39.987,8.162a.967.967,0,0,0,1.406.565,7.726,7.726,0,0,1,11.518,6.739A7.734,7.734,0,0,1,45.178,23.2H43.244V21.266H38.815c-.017-.041-.032-.08-.05-.119l3.126-3.129-4.1-4.1-3.129,3.129-.119-.053V12.565h-5.8v4.429l-.119.049L25.5,13.918l-4.1,4.1,3.129,3.129c-.017.039-.033.078-.049.119H20.043V23.2h-2.9a6.767,6.767,0,1,1,0-13.534Zm0,0",
    transform: "translate(-6.976 0)",
    fill: "#6c6a6c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.2d66609ef0e220454df6a0ddaad44543.svg";
export { ForwardRef as ReactComponent };